<template>
  <vf-loader
    class="fixed-0 z-overlay m-a rounded-2xl bg-black bg-op-80 c-white outline-1 forced-colors:outline"
    style="width: 9rem; height: 9rem"
  />
</template>
